export const WORKING_HOURS_GROUPING_MODEL = "working-hours-grouping";

const workingHoursGroupingModel = {
  name: ""
};

export default workingHoursGroupingModel;
